import {setupFileUploader} from "../../common/filesUploader";

function initCustomerDocumentsIndex() {
	// Setup Uppy File Manager
	const filesContainer = document.querySelector('.files-container');

	let existingFiles = [];

	try {
		existingFiles = JSON.parse(document.querySelector('input[name="existing_files"]').value);
	} catch (e) {
		alert('Error reading existing files');
		console.log(e)
	}

	let filesDashboard = setupFileUploader(
		{
			target: filesContainer,
			_allowDeletion: window['canDeleteDocuments'],
		},
		null,
		existingFiles
	)

	filesDashboard.fillParentContainer();
}

export {initCustomerDocumentsIndex}
